const scrollToSection = {
  /**
   * Scroll to the section
   *
   * @param {HTMLElement} section The section element
   */
  scroll(section) {
    const scrollPos = window.scrollY || window.pageYOffset
    const rect = section.getBoundingClientRect()
    const windowSize = window.innerWidth
    let paddingSize = 20

    if (windowSize >= 768) {
      paddingSize = 40
    }

    if (windowSize >= 992) {
      paddingSize = 60
    }

    window.scroll({
      top: scrollPos + rect.top - paddingSize * 2,
    })
  },
  init() {
    const elements = document.querySelectorAll('[data-action="scroll"]')

    Array.from(elements).forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault()
        const { section } = el.dataset || ''
        const href = el.getAttribute('href')
        if (section) {
          const sectionEl = document.getElementById(section)
          if (sectionEl) {
            this.scroll(sectionEl)
          } else if (href) {
            window.location = href
          }
        }
        e.stopPropagation()
      })
    })

    const { hash } = window.location

    if (hash) {
      const sectionEl = document.getElementById(hash)
      // eslint-disable-next-line no-restricted-globals
      history.replaceState('', document.title, window.location.pathname + window.location.search)
      if (sectionEl) {
        this.scroll(sectionEl)
      }
    }
  },
}

export default scrollToSection
